import { Link, useLocation } from "react-router-dom";
import { Phone, MapPin, CalendarCheck } from "lucide-react";

const ROUTE_URL = "https://www.google.com/maps/dir/?api=1&destination=Herenweg+165+3645+DK+Vinkeveen";

export const MobileActionBar = () => {
  const { pathname } = useLocation();
  const detailMatch = pathname.match(/^\/occasions\/([^/]+)$/);
  const carId = detailMatch ? detailMatch[1] : null;

  return (
    <div
      data-testid="mobile-action-bar"
      className={`md:hidden fixed bottom-0 left-0 right-0 z-40 grid ${carId ? "grid-cols-3" : "grid-cols-2"} bg-white/95 backdrop-blur-lg border-t border-black/10 shadow-[0_-4px_20px_rgba(0,0,0,0.06)]`}
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a
        href="tel:0297261333"
        data-testid="mobile-bar-call"
        className="flex items-center justify-center gap-2 py-4 text-primary font-semibold text-sm border-r border-black/10 active:bg-primary/5 transition-colors"
      >
        <Phone size={18} /> Bel ons
      </a>

      {carId && (
        <Link
          to={`/contact?auto=${carId}`}
          data-testid="mobile-bar-proefrit"
          className="flex items-center justify-center gap-2 py-4 bg-primary text-white font-semibold text-sm active:bg-primary-light transition-colors"
        >
          <CalendarCheck size={18} /> Proefrit
        </Link>
      )}

      <a
        href={ROUTE_URL}
        target="_blank"
        rel="noreferrer"
        data-testid="mobile-bar-route"
        className="flex items-center justify-center gap-2 py-4 text-primary font-semibold text-sm border-l border-black/10 active:bg-primary/5 transition-colors"
      >
        <MapPin size={18} /> Route
      </a>
    </div>
  );
};
